import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.css';

export default function CategoryBody({ itemPerRow, children }) {
    const classes = classNames({
        'category-body': true,
        [`grid-template-${itemPerRow}-columns`]: !!itemPerRow
    })
    return (
        <div className={classes}>{children}</div>
    )
}

CategoryBody.defaultProps = {
    itemPerRow: 4,
}

CategoryBody.propTypes = {
    itemPerRow: PropTypes.oneOf([1, 2, 3, 4, 5])
}